/**
 * Medical reference data — Vital parameters
 *
 * The monitored parameters and their physiological bounds + default alarm
 * thresholds. Single source of truth: the Zustand store seeds from this, and
 * `npm run check:medical` validates every scenario target against the [min,max]
 * bounds declared here.
 *
 * Each parameter: { current, target, min, max, alarmLow, alarmHigh, unit }
 *   min/max          — physiological display/clamp bounds
 *   alarmLow/High     — default alarm thresholds
 */
export const VITAL_PARAMETERS = {
  HR: { current: 80, target: 80, min: 30, max: 200, alarmLow: 50, alarmHigh: 120, unit: 'bpm' },
  SpO2: { current: 99, target: 99, min: 70, max: 100, alarmLow: 90, alarmHigh: 100, unit: '%' },
  NIBP_Sys: { current: 120, target: 120, min: 60, max: 260, alarmLow: 90, alarmHigh: 160, unit: 'mmHg' },
  NIBP_Dia: { current: 80, target: 80, min: 40, max: 150, alarmLow: 50, alarmHigh: 110, unit: 'mmHg' },
  EtCO2: { current: 38, target: 38, min: 0, max: 100, alarmLow: 30, alarmHigh: 50, unit: 'mmHg' },
  RR: { current: 14, target: 14, min: 0, max: 60, alarmLow: 8, alarmHigh: 30, unit: '/min' },
  Temp: { current: 36.8, target: 36.8, min: 32, max: 42, alarmLow: 36, alarmHigh: 38.5, unit: '°C' },
  ABP_Sys: { current: 118, target: 118, min: 60, max: 260, alarmLow: 90, alarmHigh: 160, unit: 'mmHg' },
  ABP_Dia: { current: 76, target: 76, min: 40, max: 150, alarmLow: 50, alarmHigh: 110, unit: 'mmHg' },
  CVP: { current: 4, target: 4, min: 0, max: 20, alarmLow: 2, alarmHigh: 12, unit: 'mmHg' },
};
